import z from 'zod';

export const queryParamsSchema = z.object({
  page: z.coerce.number().optional(),
  perPage: z.coerce.number().optional(),
  order: z.enum(['asc', 'desc']).optional(),
  search: z.string().optional(),
});

export type QueryParams = z.infer<typeof queryParamsSchema>;
